export default function(x, y) {
  x = Math.abs(x);
  y = Math.abs(y);
  var a = Math.max(x, y);
  var b = Math.min(x, y) / (a ? a : 1);

  return a * Math.sqrt(1 + Math.pow(b, 2));
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/proj4/lib/common/hypot.js
// module id = 92
// module chunks = 0